import { bufferToUrl } from '../helpers';
export default [
    '$rootScope',
    '$mdDialog',
    'LogService',
    'WebClientService',
    function ($rootScope, $mdDialog, logService, webClientService) {
        const log = logService.getLogger('AvatarArea-C');
        return {
            restrict: 'EA',
            scope: true,
            bindToController: {
                onChange: '=',
                loadAvatar: '=',
                enableClear: '=?',
                color: '=?',
            },
            controllerAs: 'ctrl',
            controller: [function () {
                    this.isLoading = false;
                    this.avatar = null;
                    const avatarFormat = webClientService.appCapabilities.imageFormat.avatar;
                    this.$onInit = function () {
                        this.setAvatar = (avatarBytes) => {
                            this.avatar = (avatarBytes === null)
                                ? null
                                : bufferToUrl(avatarBytes, avatarFormat, log);
                        };
                        this.imageChanged = (image, notify = true) => {
                            this.isLoading = true;
                            if (notify === true && this.onChange !== undefined) {
                                this.onChange(image);
                            }
                            this.setAvatar(image);
                            this.isLoading = false;
                        };
                        if (this.loadAvatar !== undefined) {
                            this.isLoading = true;
                            this.loadAvatar
                                .then((image) => {
                                $rootScope.$apply(() => {
                                    this.setAvatar(image);
                                    this.isLoading = false;
                                });
                            })
                                .catch(() => {
                                $rootScope.$apply(() => {
                                    this.isLoading = false;
                                });
                            });
                        }
                        this.delete = () => {
                            this.imageChanged(null, true);
                        };
                        this.modify = (ev) => {
                            $mdDialog.show({
                                controllerAs: 'ctrl',
                                controller: function () {
                                    this.avatar = null;
                                    this.apply = () => $mdDialog.hide(this.avatar);
                                    this.cancel = () => $mdDialog.cancel();
                                    this.changeAvatar = (image) => this.avatar = image;
                                },
                                template: `
                                <md-dialog translate-attr="{'aria-label': 'messenger.UPLOAD_AVATAR'}">
                                    <form ng-cloak>
                                     <md-toolbar>
                                      <div class="md-toolbar-tools">
                                       <h2 translate>messenger.UPLOAD_AVATAR</h2>
                                       </div>
                                       </md-toolbar>
                                        <md-dialog-content>
                                            <div class="md-dialog-content avatar-area editor">
                                                <avatar-editor on-change="ctrl.changeAvatar"></avatar-editor>
                                            </div>
                                        </md-dialog-content>
                                        <md-dialog-actions layout="row" >
                                              <md-button ng-click="ctrl.cancel()">
                                               <span translate>common.CANCEL</span>
                                                </md-button>
                                          <md-button ng-click="ctrl.apply()">
                                             <span translate>common.OK</span>
                                          </md-button>
                                        </md-dialog-actions>
                                    </form>
                                </md-dialog>

                            `,
                                parent: angular.element(document.body),
                                targetEvent: ev,
                                clickOutsideToClose: true,
                            })
                                .then((newImage) => {
                                if (this.enableClear === true || newImage !== null) {
                                    this.imageChanged(newImage, true);
                                }
                            }, () => null);
                        };
                    };
                }],
            template: `
                <div class="avatar-area overview">
                    <div class="avatar-image" ng-style="{ 'background-color': ctrl.color }">
                        <div class="loading-element" ng-class="{'active': ctrl.isLoading}">
                            <md-progress-circular
                                    class="md-primary"
                                    md-diameter="96"></md-progress-circular>

                        </div>
                        <img ng-src="{{ ctrl.avatar }}" ng-if="ctrl.avatar !== null">
                    </div>
                    <div class="avatar-area-navigation"  layout="row" layout-wrap layout-margin layout-align="center">

                        <md-button type="submit" class="md-raised" ng-click="ctrl.delete()" ng-if="ctrl.enableClear === true">
                            <span translate>common.DELETE</span>
                        </md-button>
                        <md-button type="submit" class="md-raised md-primary" ng-click="ctrl.modify()">
                            <span translate>messenger.UPLOAD_AVATAR</span>
                        </md-button>
                    </div>
                    </div>
                </div>
            `,
        };
    },
];
